<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" />
    <empty-component v-if="isEmpty" />
    <add-btn @add="handleAddPayer" />
    <van-list v-model="loading" :finished="noOrderFinished"  finished-text="没有更多了" @load="handleList" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell-group>
        <van-cell v-for="(item,index) in list" :title="`${item.contPayCompanyName}（${item.createBy}）`" :key="index" style="padding-top: 20px;padding-bottom: 20px">
          <template #right-icon>
            <van-button type="info" size="mini" plain @click="editPayer(item)">修改</van-button>
            <van-button size="mini" color="#ee0a24" plain @click="deletePayer(item)">删除</van-button>
          </template>
        </van-cell>
      </van-cell-group>
    </van-list>

    <van-dialog v-model="show" title="付款单位" width="95%" style="height:30%" class="editClue" :beforeClose="beforeClose" show-cancel-button>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-field v-model="form.contPayCompanyName" label="付款单位" placeholder="请输入付款单位" :rules="[{ required: true }]" required />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import TotalComponent from '@/components/common/Total'
import EmptyComponent from '@/components/common/Empty'
import AddBtn from '@/components/common/AddBtn'
import { Toast, Dialog } from 'vant'
export default {
  name: 'custClue',
  components: {
    SearchComponent, EmptyComponent, TotalComponent, AddBtn, [Toast.name]: Toast, [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      isEmpty: false,
      show: false,
      isAdd: true,
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: ''
      },
      loading: false,
      noOrderFinished: false,
      list: [],
      total: 0,
      searchValue: '',
      // options: {
      //   // 客户类型字典
      //   custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      //   // 客户来源字典
      //   custSourceOptions: this.$store.state.dictOptions.custSource || [],
      //   // 客户状态
      //   custStatusOptions: this.$store.state.dictOptions.custStatus || []
      // },
      contractId: '',
      form: {
        contPayCompanyName: null,
        contractId: null
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractId: '',
        contPayCompanyName: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  created() {
    if (this.$route.query.contractId) {
      this.contractId = this.$route.query.contractId
      this.form.contractId = this.$route.query.contractId
      this.queryParams.contractId = this.$route.query.contractId
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '付款单位'
      await this.handleList()
    },
    QueryReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        contractId: this.contractId
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.isEmpty = false
      this.QueryReset()
      this.queryParams.contPayCompanyName = this.searchValue = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      this.isEmpty = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleList()
      // this.handleList();
    },
    async handleList() {
      this.loading = true
      // this.queryParams.custName = this.$route.query.custName || ''
      const res = await payment.listPayer(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.loading = false
        this.noOrderFinished = this.list.length >= res.total
      }
    },
    onLoad() {
      this.handleList()
    },
    handleAddPayer() {
      this.isAdd = true
      this.show = true
      this.form = {
        contPayCompanyName: null,
        contractId: this.contractId
      }
    },
    editPayer(item) {
      this.isAdd = false
      this.show = true
      this.form = item
    },
    deletePayer(item) {
      const that = this
      Dialog.confirm({
        message: '是否删除该付款单位'
      })
        .then(() => {
          payment.deletePayer(item.contPayCompanyId).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                that.queryCustList()
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    async beforeClose(type, done) {
      if (type === 'confirm') {
        if (this.isAdd) {
          try {
            await this.$refs.form.validate()
            await payment.addPayer(this.form)
              .then(() => {
                Toast.success('添加成功')
                setTimeout(() => {
                  this.show = false
                  this.queryCustList()
                }, 500)
              }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        } else {
          try {
            await this.$refs.form.validate()
            await payment.updatePayer(this.form)
              .then(() => {
                Toast.success('修改成功')
                setTimeout(() => {
                  this.show = false
                  this.queryCustList()
                }, 500)
              }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        }
      } else {
        done()
        this.show = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/ .van-dialog__content {
  height: 46%;
}
</style>
